import React from 'react'
import {
  Button,
  Input,
  Modal,
  Col,
  Row,
  Table,
  Pagination,
  Space,
  message, ConfigProvider, InputNumber, Select
} from 'antd'
import {
  Link,
} from "react-router-dom";
import {OrderedListOutlined,CopyOutlined} from '@ant-design/icons';
import {ReactSortable} from "react-sortablejs";
import copy from 'copy-to-clipboard';
import './index.less'
import zhCN from "antd/es/locale/zh_CN";
import NoticeEmitter from "../../utils/NoticeUtil";

import {removeToken} from '../../utils/cookie'
import {
  getCategorieList,
  getProductChangePriceAndName,
  getProductRecycleList,
  getProductRecycleDelete,
  getProductRecycleRecovery
} from '../../constants/api'

import {COMMON_ROUTER} from "../../constants";

const {Option} = Select
export default class Recycle extends React.Component {

  constructor() {
    super();

    NoticeEmitter.addListener('SHOPID_KEY', (value) => {
      console.log('连锁商店商品=====================================' + value)
      this.setState({
            shopId: value,
            categoryProduct: [],
            inputProductName: '',
            inputProductCode: ''
          }, () => this.searchCategory(value, this.state.templateId)
      )
    })
  }

  state = {
    templateId: 1,//模板ID
    shopId: 0,//门店ID

    tempCategoryId: 0,//选中分类ID
    category: [],//分类数据

    recoveryVisible: false,//恢复商品模态框
    delete1Visible: false,//删除1
    deleteVisible: false,//删除2
    xmCategoryIdOption: 0, //操作的商品分类ID
    productIdOption: 0,//操作的商品ID

    categoryProduct: [],//右侧商品数据
    //右侧商品分页
    current: 1,
    total: 0,
    pageSize: 30,
    selectedRowKeys: [], //多选商品

    platformType: null,//平台类型

    inputProductCode: '',//搜索商品码
    inputProductName: '',//搜索商品名称

    isSort: false,//是否点击排序
    loadingSort: false,//排序保存加载

    bigImgVisible: false, //大图弹窗
    bigImgUrl: '',//大图URL

    tempProductShelfNumber: '',//货架数

    sortProductVisible: false,//商品排序选择店

    categroyNameDefault: '',//默认分类名称
  }

  componentWillMount() {
    if (this.props.location.state) {
      this.setState({
        tempCategoryId: this.props.location.state.tempCategoryId
      })
    }
  }

  componentDidMount() {
    this.getTemplateId()
  }

  getTemplateId = () => {
    let storage = window.localStorage;
    let templateId = storage.getItem('templateId');
    let platformType = storage.getItem('platformType');
    let shopId = storage.getItem('shopId');
    if (templateId && platformType) {
      this.setState({
        templateId: templateId,
        platformType: platformType,
        shopId: shopId,
      }, () => {
        this.searchCategory(shopId, templateId);
      })
    } else {
      message.error('请先选择总店', 1)
    }
  }

  //根据门店ID查询商品分类
  searchCategory(shop_id, templateId) {
    getCategorieList({
      pageIndex: 1,
      pageSize: 200,
      sortName: "",
      sortType: "descending",
      shopId: shop_id,
      templateId: templateId
    }).then((res) => {
      if (res.status === 200) {
        let data = res.data
        if (data.code === 0) {
          if (data.data.records && data.data.records.length > 0) {
            console.log(data.data.records[0].categorieName)
            this.setState({
              category: data.data.records,
              // categroyNameDefault: data.data.records[0].categorieName
            }, () => {
              if (data.data.records.length > 0) {
                // this.searchProductById(1, data.data.records[0].categorieId, '', '', this.state.pageSize)
                this.searchProductById(1, '', '', '', this.state.pageSize)
              }
            });
          }
        } else if (data.code === 50) {
          message.error(data.msg)
          removeToken();
        } else {
          message.error(data.msg)
        }
      }
    }).catch(error => {
      message.error(error.toString())
    })
  }

  //用于操作后的刷新
  searchCategoryOption(shop_id, category_id) {
    const _this = this;
    getCategorieList({
      pageIndex: 1,
      pageSize: 100,
      sortName: "",
      sortType: "descending",
      shopId: shop_id,
      templateId: this.state.templateId
    }).then((res) => {
      if (res.status === 200) {
        let data = res.data
        if (data.code === 0) {
          _this.setState({
            category: data.data.records,
          }, () => {
            if (data.data.records.length > 0) {
              _this.searchProductById(1, category_id, '', '', _this.state.pageSize)
            }
          });
        } else if (data.code === 50) {
          message.error(data.msg)
          removeToken();
        } else {
          message.error(data.msg)
        }
      }
    }).catch(error => {
      message.error(error.toString())
    })
  }

  //根据商品分类ID查询商品列表
  searchProductById(current, categorieId, name, barCode, pageSize) {
    this.setState({tempCategoryId: categorieId, isSort: false});
    const _this = this;
    getProductRecycleList({
      categoryId: categorieId,
      pageIndex: current,
      pageSize: pageSize,
      sortName: "",
      sortType: "descending",
      templateId: this.state.templateId,
      productName: name,
      barCode: barCode
    }).then((res) => {
      if (res.status === 200) {
        let data = res.data
        if (data.code === 0) {
          _this.setState({
            categoryProduct: data.data.records,
            total: data.data.total,
            current: data.data.current
          });
        } else if (data.code === 50) {
          message.error(data.msg)
          removeToken();
        } else {
          message.error(data.msg)
        }
      }
    }).catch(error => {
      message.error(error.toString())
    })
  }

  onChangePage(page, pageSize) {
    this.setState({current: page}, () => {
      this.searchProductById(page, this.state.tempCategoryId, '', '', this.state.pageSize)
    })
  }
  onChangePageSize(page, pageSize) {
    this.setState({current: page, pageSize: pageSize}, () => {
      this.searchProductById(page, this.state.tempCategoryId, '', '', pageSize)
    })
  }

  deleteGoods = () => {
    getProductRecycleDelete({
      id: this.state.productIdOption,
      shopId: this.state.shopId,
      templateId: this.state.templateId,
      platformType: this.state.platformType
    }).then((res) => {
      if (res.status === 200) {
        let data = res.data
        if (data.code === 0) {
          this.setState({
            deleteVisible: false
          }, () => {
            this.searchCategoryOption(this.state.shopId, this.state.xmCategoryIdOption)
            message.success('删除成功')
          })
        } else if (data.code === 50) {
          message.error(data.msg)
          removeToken();
        } else {
          message.error(data.msg)
          this.setState({
            deleteVisible: false
          })
        }
      }
    }).catch(error => {
      message.error(error.toString())
    })
  }
  recoveryGoods = () => {
    getProductRecycleRecovery({
      id: this.state.productIdOption,
      shopId: this.state.shopId,
      templateId: this.state.templateId,
      platformType: this.state.platformType
    }).then((res) => {
      if (res.status === 200) {
        let data = res.data
        if (data.code === 0) {
          this.setState({
            recoveryVisible: false
          }, () => {
            this.searchCategoryOption(this.state.shopId, '')
            message.success('恢复成功')
          })
        } else if (data.code === 50) {
          message.error(data.msg)
          removeToken();
        } else {
          message.error(data.msg)
          this.setState({
            recoveryVisible: false
          })
        }
      }
    }).catch(error => {
      message.error(error.toString())
    })
  }

  start = () => {
    this.setState({loading: true});
    // ajax request after empty completing
    setTimeout(() => {
      this.setState({
        selectedRowKeys: [],
        loading: false,
      });
    }, 1000);
  };

  onSelectChange = selectedRowKeys => {
    console.log('selectedRowKeys changed: ', selectedRowKeys);
    this.setState({selectedRowKeys});
  };

  onHandleOk = (type) => {
    console.log(type)
    switch (type) {
      case 'recovery':
        this.recoveryGoods();
        break;
      case 'delete1':
        this.setState({
          delete1Visible: false,
          deleteVisible: true
        })
        break;
      case 'delete':
        this.deleteGoods();
        break;
      default:
        break;
    }
  }
  onHandleCancel = (type) => {
    switch (type) {
      case 'recovery':
        this.setState({
          recoveryVisible: false
        })
        break;
      case 'delete1':
        this.setState({
          delete1Visible: false
        })
        break;
      case 'delete':
        this.setState({
          deleteVisible: false
        })
        break;
      default:
        break;
    }
  }

  onShowModal = (type, xmCategoryId, productId) => {
    this.setState({
      xmCategoryIdOption: xmCategoryId,
      productIdOption: productId,
    })
    switch (type) {
      case 'recovery':
        this.setState({
          recoveryVisible: true
        })
        break;
      case 'delete':
        this.setState({
          delete1Visible: true,
          // deleteVisible: true
        })
        break;
      default:
        break;
    }
  }

  /*排序序号的添加*/
  changeSort = (e) => {
    this.setState({
      sortNum: e.target.value
    })
  }

  changeInputName = e => {
    const {value} = e.target;
    this.setState({inputProductName: value})
  }
  changeInputCode = e => {
    const {value} = e.target;
    this.setState({inputProductCode: value})
  }

  /**
   * @Description: 可编辑单元格
   * @Author Jiang
   * @Date 2020/9/7 9:26
   */
  onTextChange = (type, record, e) => {
    if (e.keyCode == 13) {
      let rows = this.state.categoryProduct
      if (this.state.shopId == 0) {
        let row = rows.find(item => item.productId === record.productId);
        if (row) {
          if (type == 'goods') {
            row.productName =e.target.value
          } else if (type == 'price') {
            row.price =e.target.value
          } else if (type == 'shelfNumber') {
            row.shelfNumber =e.target.value
          }
          // row.countNum = e.target.value;
        }
        this.setTextChange(row)
      } else {
        let row = rows.find(item => item.productRelationId === record.productRelationId);
        if (row) {
          if (type == 'goods') {
            row.productName =e.target.value
          } else if (type == 'price') {
            row.price =e.target.value
          } else if (type == 'shelfNumber') {
            row.shelfNumber =e.target.value
          }
          // row.countNum = e.target.value;
        }
        this.setTextChange(row)
      }
      //保存编辑后的数据
    }


  }

  /**
   * @Description: 直接修改商品及价格
   * @Author Jiang
   * @Date 2020/9/7 14:00
   */
  setTextChange = (row) => {
    getProductChangePriceAndName({
      productId: this.state.shopId == 0 ? row.productId : row.productRelationId,
      // productName: this.state.tempProductName,
      // productPrice: this.state.tempProductPrice,
      // shelfNumber: this.state.tempProductShelfNumber,
      productName: row.productName,
      productPrice: row.price,
      shelfNumber: row.shelfNumber,
      shopId: this.state.shopId,
      templateId: this.state.templateId
    }).then((res) => {
      if (res.status === 200) {
        let data = res.data
        if (data.code === 0) {
          message.success("修改成功", 1)
        } else if (data.code === 50) {
          message.error(data.msg)
          removeToken();
        } else {
          message.error(data.msg)
        }
      }
    }).catch(error => {
      message.error(error.toString())
    })
  }

  showSortSave = () => {
    const _this = this;
    _this.setState({sortProductVisible: true})
  };
  showSort = () => {
    this.setState({
      isSort: true,
    });
  };
  hideSort = () => {
    this.setState({
      isSort: false,
    });
  };
  sortFirst = (item, index) => {
    const sortProducts = [...this.state.categoryProduct]
    sortProducts.splice(index, 1)
    sortProducts.unshift(item)
    this.setState({categoryProduct: sortProducts})
  }

  onPressEnterSort = (item, index, e) => {
    console.log(e.target.value)
    console.log(e.target.value - 1)
    const sortProducts = [...this.state.categoryProduct]
    sortProducts.splice(index, 1)
    sortProducts.splice(e.target.value - 1, 0, item);
    this.setState({categoryProduct: sortProducts})
  }

  onChangeInputSort = (value) => {
    console.log('changed', value);
  }

  onChangeSort = (pagination, filters, sorter, extra) => {
    console.log('params', pagination, filters, sorter, extra);
    this.setState({categoryProduct: extra.currentDataSource})
  }

  showBigImg = (imageUrl) => {
    this.setState({bigImgVisible: true, bigImgUrl: imageUrl})
  }
  onHandleImgOk = (e) => {
    this.setState({
      bigImgVisible: false,
    });
  }
  onHandleImgCancel = (e) => {
    this.setState({
      bigImgVisible: false,
    });
  }

  onBlurShelfNumber = (type, record, e) =>{
    console.log('blur-----------------');
    let rows = this.state.categoryProduct
    if (this.state.shopId == 0) {
      let row = rows.find(item => item.productId === record.productId);
      if (row) {
        if (type == 'goods') {
          if (row.productName === e.target.value) {

          } else {
            row.productName = e.target.value
            this.setTextChange(row)
          }
        } else if (type == 'price') {
          if (row.price === e.target.value) {

          } else {
            row.price = e.target.value
            this.setTextChange(row)
          }
        } else if (type == 'shelfNumber') {
          if (row.shelfNumber === e.target.value) {

          } else {
            row.shelfNumber = e.target.value
            this.setTextChange(row)
          }
        }
      }
      // this.setTextChange(row)
    } else {
      let row = rows.find(item => item.productRelationId === record.productRelationId);
      if (row) {
        if (type == 'goods') {
          if (row.productName === e.target.value) {

          } else {
            row.productName = e.target.value
            this.setTextChange(row)
          }
        } else if (type == 'price') {
          if (row.price === e.target.value) {

          } else {
            row.price = e.target.value
            this.setTextChange(row)
          }
        } else if (type == 'shelfNumber') {
          if (row.shelfNumber === e.target.value) {

          } else {
            row.shelfNumber = e.target.value
            this.setTextChange(row)
          }
        }
      }
      // this.setTextChange(row)
    }
  }

  copy = (content) => {
    console.log(content)
    if (copy(content)) {
      message.success('复制成功')
    }
  }

  changeRecycleCate = value => {
    console.log(value)
    this.setState({tempCategoryId: value, inputProductName: '', inputProductCode: ''}, ()=>{
      this.searchProductById(1, value, '', '', this.state.pageSize)
    })
    if (value == ''){
      this.setState({categroyNameDefault: '全部'})
    }
    this.state.category.map((item,index) =>{
      if (item.categorieId == value) {
        this.setState({categroyNameDefault: item.categorieName})
      }
    })
  };

  render() {
    const _this = this
    const columnsP = [
      {
        title: '条形码',
        dataIndex: 'barCode',
        render: (text, record) => (
            <div style={{display: "flex", flexDirection: "row"}}>
              <span>{record.barCode}</span>
              <div style={{marginLeft: 5}} onClick={this.copy.bind(this, record.barCode)}><CopyOutlined style={{fontSize: '14px', color: '#0b68d4', cursor: "pointer"}}/></div>
            </div>
        ),
      },
      {
        title: '分类名称',
        dataIndex: '',
        render: (text, record) => (
            <div style={{display: "flex", flexDirection: "row"}}>
              {
                this.state.category.map((item,index)=>{
                  if (record.xmCategoryId == item.categorieId) {
                    return (<div key={item.categorieId}>{item.categorieName}</div>)
                  }
                })
              }
            </div>
        ),
      },
      {
        title: '商品',
        dataIndex: 'product',
        render: (text, record) => (
          <div>
            {
              <div
                style={{height: 70, display: "flex", flexDirection: "row", justifyContent: "flex-start"}}>
                <img style={{width: 70, height: 70, cursor: "pointer"}} src={record.imageUrl}
                onClick={_this.showBigImg.bind(this, record.imageUrl)}/>
                <div style={{
                  textAlign: "center",
                  display: "flex",
                  flexDirection: "row",
                  alignItems: "center",
                  marginLeft: "2px",
                }}>{
                  record.productName
                  // this.state.platformType == 5 ?
                  //   <Input.TextArea
                  //     defaultValue={record.productName}
                  //     style={{width: '420px', border: "solid 1px #eaeaea"}}
                  //     maxLength = {50}
                  //     onChange={(e) => this.setState({tempProductName: e.target.value})}
                  //     onKeyDown={
                  //       this.onTextChange.bind(this, 'goods', record)
                  //     }
                  //     onBlur={this.onBlurShelfNumber.bind(this, 'goods', record)}
                  //   /> : record.productName
                }
                </div>
              </div>
            }
          </div>
        ),
      },
      {
        title: '价格',
        dataIndex: 'price',
        sorter: (a, b) => a.price- b.price,
        render: (text, record) => (
          <div>
            {
              // this.state.platformType == 5 ?
              //   <Input
              //     defaultValue={record.price}
              //     style={{width: '100px', border: "0"}}
              //     onChange={(e) => this.setState({tempProductPrice: e.target.value})}
              //     onKeyDown={
              //       this.onTextChange.bind(this, 'price', record)
              //     }
              //     onBlur={this.onBlurShelfNumber.bind(this, 'price', record)}
              //   /> : record.price
              record.price
            }
          </div>
        ),
      },
      {
        title: '发单价',
        dataIndex: 'shelfNumber',
        render: (text, record) => (
            <div>
              {
                // this.state.platformType == 5 ?
                //     <Input
                //         defaultValue={record.shelfNumber}
                //         style={{width: '100px', border: "0"}}
                //         onChange={(e) => this.setState({tempProductShelfNumber: e.target.value})}
                //         onKeyDown={
                //           this.onTextChange.bind(this, 'shelfNumber', record)
                //         }
                //         onBlur={this.onBlurShelfNumber.bind(this, 'shelfNumber', record)}
                //     /> : record.shelfNumber
                record.shelfNumber
              }
            </div>
        ),
      },
      {
        title: '操作',
        dataIndex: 'option',
        render: (text, record) => (
          <Space size="middle">
            {
              // _this.state.platformType == 4 ? <Link to={{
              //   pathname: COMMON_ROUTER + `/editGoods`,
              //   state: {
              //     templateId: this.state.templateId,
              //     shopId: this.state.shopId,
              //     id: record.productId,
              //     platformType: this.state.platformType,
              //     tempCategoryId: this.state.tempCategoryId
              //   }
              // }}><span>编辑</span></Link> : _this.state.platformType == 5 ?
                <Link to={{
                  pathname: COMMON_ROUTER + `/recycle/edit-goods`,
                  state: {
                    templateId: this.state.templateId,
                    shopId: this.state.shopId,
                    id: record.productId,
                    platformType: this.state.platformType,
                    tempCategoryId: this.state.tempCategoryId
                  }
                }}><span>编辑</span></Link>
                  // : null
            }

            {
                <a style={{color: "#ff9900"}} onClick={_this.onShowModal.bind(this, 'recovery', record.xmCategoryId, record.productId)}>恢复</a>
            }
            <a style={{color: "#eb2509"}}
               onClick={_this.onShowModal.bind(this, 'delete', record.xmCategoryId, record.productId)}>删除</a>
          </Space>
        ),
      },
    ];
    const columnsBranch = [
      {
        title: '条形码',
        dataIndex: 'barCode',
        render: (text, record) => (
            <div style={{display: "flex", flexDirection: "row"}}>
              <span>{record.barCode}</span>
              <div style={{marginLeft: 5}} onClick={this.copy.bind(this, record.barCode)}><CopyOutlined style={{fontSize: '14px', color: '#0b68d4'}}/></div>
            </div>
        ),
      },
      {
        title: '商品',
        dataIndex: 'product',
        render: (text, record) => (
          <div>
            {
              <div
                style={{height: 70, display: "flex", flexDirection: "row", justifyContent: "flex-start"}}>
                <img style={{width: 70, height: 70, cursor: "pointer"}} src={record.imageUrl}
                     onClick={_this.showBigImg.bind(this, record.imageUrl)}/>
                <div style={{
                  textAlign: "center",
                  display: "flex",
                  flexDirection: "row",
                  alignItems: "center",
                  marginLeft: "5px",
                }}>{
                  record.productName
                  // this.state.platformType == 5 ?
                  //   <Input
                  //     defaultValue={record.productName}
                  //     style={{width: '420px', border: "solid 1px #eaeaea"}}
                  //     maxLength = {50}
                  //     onChange={(e) => this.setState({tempProductName: e.target.value})}
                  //     onKeyDown={
                  //       this.onTextChange.bind(this, 'goods', record)
                  //     }
                  //     onBlur={this.onBlurShelfNumber.bind(this, 'goods', record)}
                  //   /> : record.productName
                }
                </div>
              </div>
            }
          </div>
        ),
      },
      {
        title: '价格',
        dataIndex: 'price',
        sorter: (a, b) => a.price- b.price,
        render: (text, record) => (
          <div>
            {
              // this.state.platformType == 5 ?
              //   <Input
              //     defaultValue={record.price}
              //     style={{width: '100px', border: "0"}}
              //     onChange={(e) => this.setState({tempProductPrice: e.target.value})}
              //     onKeyDown={
              //       this.onTextChange.bind(this, 'price', record)
              //     }
              //     onBlur={this.onBlurShelfNumber.bind(this, 'price', record)}
              //   /> : record.price
              record.price
            }
          </div>
        ),
      },
      {
        title: '发单价',
        dataIndex: 'shelfNumber',
        render: (text, record) => (
            <div>
              {
                // this.state.platformType == 5 ?
                //     <Input
                //         defaultValue={record.shelfNumber}
                //         style={{width: '100px', border: "0"}}
                //         onChange={(e) => this.setState({tempProductShelfNumber: e.target.value})}
                //         onKeyDown={
                //           this.onTextChange.bind(this, 'shelfNumber', record)
                //         }
                //         onBlur={this.onBlurShelfNumber.bind(this, 'shelfNumber', record)}
                //     /> : record.shelfNumber
                record.shelfNumber
              }
            </div>
        ),
      },
      {
        title: '操作',
        dataIndex: 'option',
        render: (text, record) => (
          <Space size="middle">
            {
              _this.state.platformType == 4 ? <Link to={{
                pathname: COMMON_ROUTER + `/editGoods`,
                state: {
                  templateId: this.state.templateId,
                  shopId: this.state.shopId,
                  id: record.productId,
                  platformType: this.state.platformType,
                  tempCategoryId: this.state.tempCategoryId
                }
              }}><span>编辑</span></Link> : _this.state.platformType == 5 ?
                  <Link to={{
                    pathname: COMMON_ROUTER + `/flower/goods/edit-goods`,
                    state: {
                      templateId: this.state.templateId,
                      shopId: this.state.shopId,
                      id: record.productId,
                      platformType: this.state.platformType,
                      tempCategoryId: this.state.tempCategoryId
                    }
                  }}><span>编辑</span></Link> : null
            }

            {
              <a style={{color: "#ff9900"}} onClick={_this.onShowModal.bind(this, 'recovery', record.xmCategoryId, record.productRelationId)}>恢复</a>
            }
            <a style={{color: "#eb2509"}}
               onClick={_this.onShowModal.bind(this, 'delete', record.xmCategoryId, record.productRelationId)}>删除</a>
          </Space>
        ),
      },
    ];
    const {selectedRowKeys, categoryProduct} = this.state;
    const rowSelection = {
      selectedRowKeys,
      onChange: this.onSelectChange,
    };
    const hasSelected = selectedRowKeys.length > 0;

    return (
      <div style={{width: "100%"}}>
        <Row className="container-recycle">
          <Col span="24" className="goods-recycle">
            <div className="goods-recycle-line1">
              <div className="goods-recycle-line1-content">
                <Select value={(this.state.categroyNameDefault == '' || this.state.categroyNameDefault == '全部') ? '全部' : this.state.categroyNameDefault}
                        style={{width: 220, marginRight: 50}}
                        bordered={true}
                        onChange={this.changeRecycleCate}
                        showSearch
                        onSearch={this.onSearch}
                        filterOption={(input, option) =>
                            option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                        }
                >
                  <Option value={''}>全部</Option>
                  {this.state.category && this.state.category.map((item) => {
                    return <Option key={item.categorieId} value={item.categorieId}>{item.categorieName}</Option>
                  })}
                </Select>
                <Input style={{width: '150px', marginRight: "5px"}} value={this.state.inputProductName}
                       onChange={this.changeInputName} placeholder="请输入商品名称"/>
                <Input style={{width: '150px'}} value={this.state.inputProductCode} onChange={this.changeInputCode}
                       placeholder="请输入条形码"/>
                <Button style={{marginLeft: '5px', marginRight: '80px'}} shape="round" type="primary"
                        onClick={this.searchProductById.bind(this, 1, this.state.tempCategoryId, this.state.inputProductName, this.state.inputProductCode, this.state.pageSize)}>
                  搜索
                </Button>
              </div>

              <div className="goods-recycle-line1-content">
                {/*{*/}
                {/*  this.state.isSort ? <Button onClick={this.hideSort} shape="round">取消排序</Button> : null*/}
                {/*}*/}
                {/*{*/}
                {/*  this.state.isSort ?*/}
                {/*      <Button style={{marginLeft: '2px', marginRight: '20px'}} type="primary" shape="round" loading={loadingSort} onClick={this.showSortSave}>保存</Button>*/}
                {/*      :*/}
                {/*      <Button style={{marginLeft: '2px', marginRight: '20px'}} type="primary" shape="round" onClick={this.showSort}>排序</Button>*/}
                {/*}*/}
              </div>
            </div>
            {
              this.state.isSort ?
                  <ReactSortable
                      style={{padding: "15px", height: "700px", overflow: 'auto'}}
                      list={categoryProduct}
                      setList={newState => {
                        this.setState({categoryProduct: newState})
                      }}
                  >
                    {categoryProduct.map((item, index) => (
                        <div key={this.state.shopId == 0 ? item.productId : item.productRelationId}>
                          <div style={{backgroundColor: '#f5f5f5',height: 1}}></div>
                          <div className="goods-recycle-sort">
                            <div style={{height: 40, display: "flex", flexDirection: "row", justifyContent: "flex-start"}}>
                              <img style={{width: 40, height: 40}} src={item.imageUrl}/>
                              <div style={{textAlign: "start",display: "flex",flexDirection: "row",alignItems: "center",marginLeft: "10px",}}>
                                {item.productName}
                              </div>
                            </div>
                            <div className="goods-recycle-sort">
                              <span style={{marginRight: '60px'}}>价格：{item.price}</span>
                              <span style={{marginRight: '50px'}}>条形码：{item.barCode}</span>
                              <InputNumber style={{marginRight: '50px'}} min={1} max={this.state.pageSize} value={index + 1}
                                           blur={(e) => console.log(e.target.value)}
                                           // onChange={this.onChangeInputSort}
                                           onPressEnter={this.onPressEnterSort.bind(this, item, index)} />
                              <span style={{marginRight: '10px'}}><OrderedListOutlined /> 拖动排序</span>
                              <a onClick={this.sortFirst.bind(this, item, index)}>置顶</a>
                            </div>
                          </div>
                        </div>
                    ))}
                  </ReactSortable>
                  :
                  <ConfigProvider locale={zhCN}>
                    <div>
                      <Table rowKey={this.state.shopId == 0 ? "productId" : 'productRelationId'}
                             // rowSelection={rowSelection}
                             columns={this.state.shopId == 0 ? columnsP : columnsBranch}
                          // pagination={{
                          //   hideOnSinglePage: true
                          // }}
                             onChange={this.onChangeSort}
                             pagination={false}
                             dataSource={categoryProduct}/>

                      <div style={{
                        display: "flex",
                        flexDirection: "row",
                        justifyContent: "flex-end",
                        padding: "0 20px 0 0"
                      }}>
                        <Pagination style={{marginTop: 20}} showQuickJumper={true} showSizeChanger={true}
                                    onShowSizeChange={this.onChangePageSize.bind(this)}
                                    current={this.state.current} pageSize={this.state.pageSize} total={this.state.total}
                                    onChange={this.onChangePage.bind(this)}/>
                      </div>

                    </div>
                  </ConfigProvider>
            }
          </Col>
        </Row>

        <Modal
            visible={this.state.delete1Visible}
            onOk={this.onHandleOk.bind(this, 'delete1')}
            onCancel={this.onHandleCancel.bind(this, 'delete1')}
            okText="确认"
            cancelText="取消"
        >
          确定将商品删除嘛？
        </Modal>
        <Modal
            visible={this.state.deleteVisible}
            onOk={this.onHandleOk.bind(this, 'delete')}
            onCancel={this.onHandleCancel.bind(this, 'delete')}
            okText="确认"
            cancelText="取消"
        >
          真的要将商品删除嘛？
        </Modal>
        <Modal
            visible={this.state.recoveryVisible}
            onOk={this.onHandleOk.bind(this, 'recovery')}
            onCancel={this.onHandleCancel.bind(this, 'recovery')}
            okText="确认"
            cancelText="取消"
        >
          确定将商品恢复嘛？
        </Modal>

        <Modal
            width={'480px'}
            visible={this.state.bigImgVisible}
            onOk={this.onHandleImgOk.bind(this)}
            onCancel={this.onHandleImgCancel.bind(this)}
            okText="确认"
            cancelText="取消"
            footer={null}
        >
          <div style={{width: '100%', height: '400px'}}>
            <img style={{width: '400px', height: '400px'}} src={this.state.bigImgUrl} />
          </div>
        </Modal>
      </div>
    );
  }
}




// WEBPACK FOOTER //
// ./src/pages/recycle/index.js